"use client";

import NextLink from "next/link";

import { useNavigationBlockerValue } from "../../context/navigationBlocker";
import { defaultUnloadMessage } from "../../hooks/useBeforeUnload";

type Props = React.ComponentProps<typeof NextLink>;

interface NextLinkEvent {
    preventDefault: () => void;
}

export default function Link({ children, ...rest }: Props) {
    const isBlocked = useNavigationBlockerValue();

    const handleOnNavigate = (event: NextLinkEvent) => {
        if (isBlocked && !window.confirm(defaultUnloadMessage)) {
            event.preventDefault();
        }
    }

    return <NextLink onNavigate={handleOnNavigate} {...rest}>{children}</NextLink>;
}
